document.addEventListener("DOMContentLoaded", function () {

  // =========================
  // Email & phone labels
  // =========================
  document
    .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
    .forEach(function (el) {
      var href = el.getAttribute("href");
      if (
        el.getAttribute("role") === "button" ||
        el.classList.contains("button") ||
        el.classList.contains("btn")
      ) {
        return;
      }

      if (href && href.startsWith("mailto:")) {
        var email = href.replace("mailto:", "").trim();
        var existing = el.getAttribute("aria-label");
        if (existing) {
          el.setAttribute("aria-label", existing + ", Email address: " + email);
        } else {
          el.setAttribute("aria-label", "Email address: " + email);
        }
      }

      if (href && href.startsWith("tel:")) {
        if (el.getAttribute("aria-label")) return;
        var text = el.textContent.trim();
        el.setAttribute("aria-label", "Phone number: " + text);
      }
    });

  // =========================
  // Third party warning
  // =========================
  var warningText = "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      var linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      var href = link.getAttribute("href");
      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      var img = link.querySelector("img");

      if (img) {
        link.removeAttribute("aria-label");
        var alt = img.getAttribute("alt") || "";
        if (!alt.includes(warningText)) {
          img.setAttribute("alt", alt ? alt + ", " + warningText : warningText);
        }
        return;
      }

      var aria = link.getAttribute("aria-label");
      var text = link.textContent.trim();

      if (aria) {
        if (!aria.includes(warningText)) {
          link.setAttribute("aria-label", aria + ", " + warningText);
        }
      } else {
        if (!text) return;
        link.setAttribute("aria-label", text + ", " + warningText);
      }
    });
  }
  setTimeout(handleExternalLinks, 500);

  // =========================
  // SVG icons
  // =========================
  var CHEVRON_DOWN =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<polyline points="6 9 12 15 18 9"></polyline>' +
    '</svg>';

  var CHEVRON_RIGHT =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<polyline points="9 6 15 12 9 18"></polyline>' +
    '</svg>';

  function isDesktop() {
    return window.matchMedia("(min-width: 768px)").matches;
  }

  // =========================
  // Click-based desktop navigation
  // =========================
  function closeMenu(holder) {
    holder.classList.remove("menu-open");
    var btn = holder.querySelector(":scope > .nav-toggle-btn");
    if (btn) btn.setAttribute("aria-expanded", "false");
  }

  function closeAllSiblings(parent) {
    parent.querySelectorAll(":scope > .nav__link__holder.menu-open").forEach(function (h) {
      closeMenu(h);
      h.querySelectorAll(".nav__link__holder.menu-open").forEach(closeMenu);
    });
  }

  var desktopHeader = document.querySelector(".page__header--desktop");

  if (desktopHeader) {
    desktopHeader.querySelectorAll(".nav__link__holder").forEach(function (holder) {
      var submenu = holder.querySelector(":scope > .nav__submenu");
      if (!submenu) return;
      if (holder.querySelector(":scope > .nav-toggle-btn")) return;

      var link = holder.querySelector(":scope > .nav__link");
      if (!link) return;
      var menuLabel = (link.textContent || "").replace(/\s+/g, " ").trim() || "Menu";

      var btn = document.createElement("button");
      btn.className = "nav-toggle-btn";
      btn.setAttribute("type", "button");
      btn.setAttribute("aria-expanded", "false");
      btn.setAttribute("aria-label", menuLabel + ", toggle submenu");
      btn.innerHTML = CHEVRON_DOWN;

      if (link.nextSibling) {
        holder.insertBefore(btn, link.nextSibling);
      } else {
        holder.appendChild(btn);
      }

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isDesktop()) return;

        var isOpen = holder.classList.contains("menu-open");
        closeAllSiblings(holder.parentNode);

        if (!isOpen) {
          holder.classList.add("menu-open");
          btn.setAttribute("aria-expanded", "true");
        }
      });

      // Collapse submenu when focus moves out of the menu holder
      holder.addEventListener("focusout", function () {
        if (!isDesktop()) return;
        setTimeout(function () {
          if (holder.classList.contains("menu-open") && !holder.contains(document.activeElement)) {
            closeMenu(holder);
          }
        }, 60);
      });
    });

    document.addEventListener("focusin", function (e) {
      if (!isDesktop()) return;
      desktopHeader.querySelectorAll(".nav__link__holder.menu-open").forEach(function (openHolder) {
        if (!openHolder.contains(e.target)) {
          closeMenu(openHolder);
        }
      });
    });

    document.addEventListener("click", function (e) {
      if (!isDesktop()) return;
      var insideHolder = e.target.closest(".page__header--desktop .nav__link__holder.menu-open");
      var insideBtn = e.target.closest(".nav-toggle-btn");
      if (!insideHolder && !insideBtn) {
        desktopHeader.querySelectorAll(".nav__link__holder.menu-open").forEach(closeMenu);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        desktopHeader.querySelectorAll(".nav__link__holder.menu-open").forEach(function (h) {
          var btn = h.querySelector(":scope > .nav-toggle-btn");
          closeMenu(h);
          if (btn) btn.focus();
        });
      }
    });
  }

  // ========================================================
  // Mobile nav: button-based drawer toggle & close button management
  // ========================================================
  var mobileNavBtn = document.querySelector('.mobile-nav-toggle');
  var mobileNavPanel = document.getElementById('mobile-nav-panel');
  var mobileNavOverlay = document.getElementById('mobile-nav-overlay');

  if (mobileNavBtn && mobileNavPanel) {
    var closeMenuBtn = mobileNavPanel.querySelector('.close-menu-btn');

    function openMobileNav() {
      mobileNavPanel.classList.add('is-open');
      if (mobileNavOverlay) mobileNavOverlay.classList.add('is-open');
      mobileNavBtn.setAttribute('aria-expanded', 'true');
      mobileNavBtn.setAttribute('aria-label', 'Close navigation menu');

      // Shift focus toward the close button with a delay to allow opening animation
      setTimeout(function () {
        var targetBtn = mobileNavPanel.querySelector('.close-menu-btn');
        if (targetBtn && typeof targetBtn.focus === 'function') {
          targetBtn.focus();
        }
      }, 200);
    }

    function resetMobileNavSubmenus() {
      if (!mobileNavPanel) return;
      mobileNavPanel.querySelectorAll('.nav__submenu--mobile').forEach(function (sub) {
        sub.classList.remove('is-open');
      });
      mobileNavPanel.querySelectorAll('.mobile__submenu__toggle').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function closeMobileNav() {
      mobileNavPanel.classList.remove('is-open');
      if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-open');
      mobileNavBtn.setAttribute('aria-expanded', 'false');
      mobileNavBtn.setAttribute('aria-label', 'Open navigation menu');
      resetMobileNavSubmenus();

      // Shift focus back toward the mobile menu toggle button with a delay
      setTimeout(function () {
        if (mobileNavBtn && typeof mobileNavBtn.focus === 'function') {
          mobileNavBtn.focus();
        }
      }, 150);
    }

    mobileNavBtn.addEventListener('click', function () {
      var isOpen = mobileNavPanel.classList.contains('is-open');
      if (isOpen) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });

    if (closeMenuBtn) {
      closeMenuBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeMobileNav();
      });
    }

    // Also support any dynamically rendered or event-delegated close buttons
    mobileNavPanel.addEventListener('click', function (e) {
      var btn = e.target.closest('.close-menu-btn');
      if (btn) {
        e.preventDefault();
        closeMobileNav();
      }
    });

    if (mobileNavOverlay) {
      mobileNavOverlay.addEventListener('click', function () {
        closeMobileNav();
      });
    }

    // Escape key closes drawer and returns focus to menu button
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNavPanel.classList.contains('is-open')) {
        closeMobileNav();
      }
    });

    // Focus trapping within the open mobile nav drawer
    mobileNavPanel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !mobileNavPanel.classList.contains('is-open')) return;

      var focusableElements = mobileNavPanel.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length === 0) return;

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    });
  }

  // =========================
  // Mobile nav: submenu toggle buttons
  // =========================
  function collapseSubmenu(submenu, btn) {
    if (submenu) {
      submenu.classList.remove('is-open');
      submenu.querySelectorAll('.nav__submenu--mobile').forEach(function (nestedSub) {
        nestedSub.classList.remove('is-open');
      });
      submenu.querySelectorAll('.mobile__submenu__toggle').forEach(function (nestedBtn) {
        nestedBtn.setAttribute('aria-expanded', 'false');
      });
    }
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
    }
  }

  document.querySelectorAll('.mobile__submenu__toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var controlsId = btn.getAttribute('aria-controls');
      var submenu = controlsId ? document.getElementById(controlsId) : null;
      if (!submenu) {
        submenu = btn.nextElementSibling;
        if (!submenu || !submenu.classList.contains('nav__submenu--mobile')) return;
      }

      var isOpen = submenu.classList.contains('is-open');

      if (isOpen) {
        // Collapsing this submenu: also collapse all nested child submenus and child buttons
        collapseSubmenu(submenu, btn);
      } else {
        // Opening this submenu: ensure any nested submenus and toggles inside are collapsed to default
        submenu.querySelectorAll('.nav__submenu--mobile').forEach(function (nestedSub) {
          nestedSub.classList.remove('is-open');
        });
        submenu.querySelectorAll('.mobile__submenu__toggle').forEach(function (nestedBtn) {
          nestedBtn.setAttribute('aria-expanded', 'false');
        });

        submenu.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // =========================
  // User account menu toggle
  // =========================
  var userToggle = document.querySelector('.user__button-toggle');
  var userWrapper = document.querySelector('.user__button');
  var userOverlay = userWrapper ? userWrapper.querySelector('.overlay') : null;

  if (userToggle && userWrapper) {
    function closeUserMenu() {
      userWrapper.classList.remove('is-open');
      userToggle.setAttribute('aria-expanded', 'false');
    }

    userToggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = userWrapper.classList.contains('is-open');
      if (isOpen) {
        closeUserMenu();
      } else {
        userWrapper.classList.add('is-open');
        userToggle.setAttribute('aria-expanded', 'true');
      }
    });

    if (userOverlay) {
      userOverlay.addEventListener('click', function () {
        closeUserMenu();
      });
    }

    document.addEventListener('click', function (e) {
      if (!userWrapper.contains(e.target)) {
        closeUserMenu();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && userWrapper.classList.contains('is-open')) {
        closeUserMenu();
        userToggle.focus();
      }
    });
  }

  // ========================================================
  // Rebuy Smart Cart trigger on minicart__label
  // Ensures clicking or keyboard activating opens Rebuy Smart Cart
  // and prevents default theme minicart from toggling.
  // ========================================================
  document.querySelectorAll('.minicart__label').forEach(function (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        e.preventDefault();
        e.stopPropagation();
        window.Rebuy.SmartCart.show();
      }
    });

    cartBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
        } else {
          cartBtn.click();
        }
      }
    });
  });

  // =========================
  // Search modal: focus management & live announcements
  // =========================
  var lastSearchTrigger = null;
  var searchAnnounceTimer = null;
  var lastAnnouncedQuery = '';

  document.querySelectorAll('.search__icon').forEach(function (btn) {
    btn.addEventListener('click', function () {
      lastSearchTrigger = btn;
    });
  });

  function handleSearchClose() {
    var liveRegion = document.getElementById('search-live-status');
    if (liveRegion) liveRegion.textContent = '';
    lastAnnouncedQuery = '';
    if (lastSearchTrigger && typeof lastSearchTrigger.focus === 'function') {
      lastSearchTrigger.focus();
    }
  }

  // Close via close icon span or overlay
  document.querySelectorAll('.search__title span, .search__title button, .search__overlay').forEach(function (el) {
    el.addEventListener('click', function () {
      setTimeout(handleSearchClose, 50);
    });

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        el.click();
      }
    });
  });

  // Close via Escape key and return focus to triggered element
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var searchContainer = document.querySelector('.search__container--abs.focused, [data-search-container].focused');
      if (searchContainer) {
        if (window.BoosterTheme && window.BoosterTheme.ELEMENTS && window.BoosterTheme.ELEMENTS.closeSearch) {
          window.BoosterTheme.ELEMENTS.closeSearch(searchContainer);
        } else {
          searchContainer.classList.remove('focused');
        }
        handleSearchClose();
      }
    }
  });

  // Announce search result count to screen reader users
  function announceSearchCount(query, count) {
    var liveRegion = document.getElementById('search-live-status');
    if (!liveRegion) return;

    var message = '';
    if (count === 0) {
      message = 'No products found for "' + query + '"';
    } else if (count === 1) {
      message = '1 product found for "' + query + '"';
    } else {
      message = count + ' products found for "' + query + '"';
    }

    liveRegion.textContent = '';
    setTimeout(function () {
      liveRegion.textContent = message;
    }, 80);
  }

  // Clear live region when user wipes the search input
  document.querySelectorAll('input[data-search]').forEach(function (input) {
    input.addEventListener('input', function () {
      var val = input.value.trim();
      if (!val) {
        var liveRegion = document.getElementById('search-live-status');
        if (liveRegion) liveRegion.textContent = '';
        lastAnnouncedQuery = '';
      }
    });
  });

  // Observe search suggestions container mutations to trigger announcement
  document.querySelectorAll('[data-search-suggest]').forEach(function (suggestContainer) {
    var observer = new MutationObserver(function () {
      clearTimeout(searchAnnounceTimer);
      searchAnnounceTimer = setTimeout(function () {
        var activeInput = document.querySelector('[data-search-container].focused input[data-search], input[data-search]');
        var query = activeInput ? activeInput.value.trim() : '';
        if (!query || query === lastAnnouncedQuery) return;

        var productCount = suggestContainer.querySelectorAll('.card--default').length;
        if (productCount === 0 && suggestContainer.children.length > 0) {
          var productLinks = suggestContainer.querySelectorAll('a[href*="/products/"]');
          if (productLinks.length > 0) {
            productCount = productLinks.length;
          }
        }

        announceSearchCount(query, productCount);
        lastAnnouncedQuery = query;
      }, 300);
    });

    observer.observe(suggestContainer, { childList: true, subtree: true });
  });

  // Also listen for Booster content update event if available
  if (window.BoosterTheme && window.BoosterTheme.events) {
    window.BoosterTheme.events.on('booster:content:update', function () {
      var activeInput = document.querySelector('[data-search-container].focused input[data-search], input[data-search]');
      var query = activeInput ? activeInput.value.trim() : '';
      if (!query || query === lastAnnouncedQuery) return;
      var suggestContainer = document.querySelector('[data-search-container].focused [data-search-suggest], [data-search-suggest]');
      if (!suggestContainer) return;

      var productCount = suggestContainer.querySelectorAll('.card--default, a[href*="/products/"]').length;
      announceSearchCount(query, productCount);
      lastAnnouncedQuery = query;
    });
  }

  // =========================
  // Disclosure panels for mega menu
  // (Replaces ARIA tab/tabpanel with aria-haspopup="dialog" / aria-expanded)
  // =========================
  document.querySelectorAll(".clean-mega-tabs").forEach(function (mega, widgetIndex) {
    var tabNav = mega.querySelector(".clean-mega-tabs__nav");
    var originalTabLinks = mega.querySelectorAll("[data-mega-tab]");
    var panels = Array.from(mega.querySelectorAll("[data-mega-panel]"));

    if (!tabNav || originalTabLinks.length === 0) return;

    var tabLinks = [];
    originalTabLinks.forEach(function (original) {
      var clone = original.cloneNode(true);
      original.parentNode.replaceChild(clone, original);
      tabLinks.push(clone);
    });

    var prefix = "mega-panel-" + widgetIndex + "-";
    var panelButtons = [];

    tabNav.removeAttribute("role");
    tabNav.removeAttribute("aria-label");

    function activateByIndex(index) {
      tabLinks.forEach(function (link, j) {
        link.classList.toggle("is-active", j === index);
      });
      panelButtons.forEach(function (btn, j) {
        var isOpen = (j === index);
        btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
        btn.classList.toggle("is-active", isOpen);
      });
      panels.forEach(function (p, j) {
        var isCurrent = (j === index);
        p.classList.toggle("is-active", isCurrent);
        if (isCurrent) {
          p.removeAttribute("hidden");
          p.setAttribute("aria-hidden", "false");
        } else {
          p.setAttribute("hidden", "");
          p.setAttribute("aria-hidden", "true");
        }
      });
      if (panels[index]) {
        var pHeight = panels[index].scrollHeight;
        var nHeight = tabNav ? tabNav.scrollHeight : 0;
        mega.style.minHeight = Math.max(430, pHeight, nHeight) + "px";
      }
    }

    tabLinks.forEach(function (link, i) {
      var btnId = prefix + "btn-" + i;
      var panelId = prefix + "content-" + i;
      var isActive = link.classList.contains("is-active");

      var btn = document.createElement("button");
      btn.className = "tab-toggle-btn" + (isActive ? " is-active" : "");
      btn.setAttribute("type", "button");
      btn.setAttribute("id", btnId);
      btn.setAttribute("aria-expanded", isActive ? "true" : "false");
      btn.setAttribute("aria-controls", panelId);
      btn.setAttribute("tabindex", "0");
      btn.setAttribute("aria-label", (link.textContent || "").replace(/\s+/g, " ").trim());
      btn.innerHTML = CHEVRON_RIGHT;

      var row = document.createElement("div");
      row.className = "tab-link-row";
      link.parentNode.insertBefore(row, link);
      row.appendChild(link);
      row.appendChild(btn);

      panelButtons.push(btn);

      if (panels[i]) {
        panels[i].removeAttribute("role");
        panels[i].setAttribute("id", panelId);
        panels[i].setAttribute("aria-labelledby", btnId);
        if (isActive) {
          panels[i].removeAttribute("hidden");
          panels[i].setAttribute("aria-hidden", "false");
        } else {
          panels[i].setAttribute("hidden", "");
          panels[i].setAttribute("aria-hidden", "true");
        }
        // Move panel directly after this category row in DOM reading order
        row.parentNode.insertBefore(panels[i], row.nextSibling);
      }

      // Activating button opens panel; focus stays on the button
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        activateByIndex(i);
      });
    });

    var activeIdx = tabLinks.findIndex(function (link) {
      return link.classList.contains("is-active");
    });
    if (activeIdx !== -1) {
      activateByIndex(activeIdx);
    }
  });
  // =========================
  // Testimonial slider A11y
  // =========================
  (function () {
    function updateTestimonialSliderA11y() {
      document
        .querySelectorAll(".testimonial-slider-section .swiper-wrapper")
        .forEach(function (wrapper) {
          const slides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
          const activeIndex = slides.findIndex(function (slide) {
            return slide.classList.contains("swiper-slide-active");
          });

          if (activeIndex === -1) return;

          slides.forEach(function (slide, index) {
            const isAccessible =
              index >= activeIndex && index <= activeIndex + 2;

            slide.setAttribute(
              "aria-hidden",
              isAccessible ? "false" : "true"
            );

            slide
              .querySelectorAll(
                "a, button, input, select, textarea, [tabindex]"
              )
              .forEach(function (element) {
                element.setAttribute(
                  "tabindex",
                  isAccessible ? "0" : "-1"
                );
              });
          });
        });
    }

    updateTestimonialSliderA11y();

    document
      .querySelectorAll(".testimonial-slider-section .swiper")
      .forEach(function (swiper) {
        swiper.addEventListener(
          "transitionend",
          updateTestimonialSliderA11y
        );
      });

    setInterval(updateTestimonialSliderA11y, 500);
  })();

  //filter on collection
  document.querySelectorAll('.filter__views').forEach(function (element) {
    element.setAttribute('tabindex', '-1');
    element.setAttribute('aria-hidden', 'true');

    element.querySelectorAll('button').forEach(function (child) {
      child.setAttribute('tabindex', '-1');
      child.setAttribute('aria-hidden', 'true');
    });
  });

  //gallery view slides 
  (function () {
    function updateProductSlidesA11y() {
      document
        .querySelectorAll(
          '.gallery__default .slider--product.slider--product-holder .slide--product'
        )
        .forEach(function (slide) {
          if (slide.getAttribute('data-bstr-slide') === 'active') {
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });
    }

    updateProductSlidesA11y();

    new MutationObserver(updateProductSlidesA11y).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-bstr-slide']
    });
  })();

  // ========================================================
  // Product Page Tabs Accessibility (.tab__container--product)
  // ========================================================
  (function () {
    // Synchronize ARIA state on tab click
    document.addEventListener("click", function (e) {
      var tab = e.target.closest(".tab__container--product .tab--product");
      if (!tab) return;
      var container = tab.closest(".tab__container--product");
      if (!container) return;

      var targetId = tab.getAttribute("aria-controls") || tab.getAttribute("data-id");

      // Update tabs (aria-selected, tabindex)
      container.querySelectorAll(".tab--product").forEach(function (t) {
        var isCurrent = (t === tab);
        t.setAttribute("aria-selected", isCurrent ? "true" : "false");
        // t.setAttribute("tabindex", isCurrent ? "0" : "-1");
      });

      // Update tab panels (hidden, aria-hidden)
      if (targetId) {
        container.querySelectorAll(".product--tab__content").forEach(function (panel) {
          var isTarget = (panel.id === targetId);
          panel.classList.toggle("tab--show", isTarget);
          if (isTarget) {
            panel.removeAttribute("hidden");
            panel.setAttribute("aria-hidden", "false");
            panel.setAttribute("tabindex", "0");
          } else {
            panel.setAttribute("hidden", "");
            panel.setAttribute("aria-hidden", "true");
            panel.setAttribute("tabindex", "-1");
          }
        });
      }
    });

    // Keyboard navigation (Enter, Space, ArrowLeft, ArrowRight)
    document.addEventListener("keydown", function (e) {
      var tab = e.target.closest(".tab__container--product .tab--product");
      if (!tab) return;

      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        tab.click();
        return;
      }

      if (["ArrowRight", "ArrowLeft", "Home", "End"].includes(e.key)) {
        e.preventDefault();
        var container = tab.closest(".tab__container--product");
        var tabs = Array.from(container.querySelectorAll(".tab--product")).filter(function (t) {
          return t.offsetParent !== null && window.getComputedStyle(t).display !== "none";
        });
        var idx = tabs.indexOf(tab);
        if (idx === -1) return;

        var nextIdx = e.key === "Home" ? 0 : e.key === "End" ? tabs.length - 1 :
          e.key === "ArrowRight" ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;
        tabs.forEach(function (t, i) {
          // t.setAttribute("tabindex", i === nextIdx ? "0" : "-1");
        });
        tabs[nextIdx].focus();
      }
    });
  })();

  // tabs default opening 
  document.querySelectorAll(".tab__container--product").forEach((container) => {
    const tabs = Array.from(
      container.querySelectorAll(".tab--product")
    );

    const firstVisibleTab = tabs.find((tab) => tab.style.display !== "none");
    if (!firstVisibleTab) return;

    const targetId = firstVisibleTab.getAttribute("aria-controls");

    tabs.forEach((tab) => {
      const selected = tab === firstVisibleTab;
      tab.classList.toggle("tab--active", selected);
      tab.setAttribute("aria-selected", String(selected));
      // tab.setAttribute("tabindex", selected ? "0" : "-1");
    });

    container.querySelectorAll(".product--tab__content").forEach((panel) => {
      const selected = panel.id === targetId;
      panel.classList.toggle("tab--show", selected);
      panel.hidden = !selected;
      panel.setAttribute("aria-hidden", String(!selected));
      panel.setAttribute("tabindex", selected ? "0" : "-1");
    });
  });


});

// Equivalent pointer and keyboard pause behavior for Booster banner sliders.
(function () {
  var initialized = new WeakSet();
  function initializeSliders() {
    document.querySelectorAll('[data-bstr-section-slider]').forEach(function (slider) {
      if (initialized.has(slider)) return;
      initialized.add(slider);
      // Replace mouse-only inline handlers; keep focus and hover state together.
      slider.removeAttribute('onmouseover');
      slider.removeAttribute('onmouseout');
      var hovered = slider.matches(':hover');
      function updatePause() {
        slider.dataset.paused = hovered || slider.contains(document.activeElement)
          ? '-1' : String(Date.now());
      }
      slider.addEventListener('mouseenter', function () {
        hovered = true;
        updatePause();
      });
      slider.addEventListener('mouseleave', function () {
        hovered = false;
        updatePause();
      });
      slider.addEventListener('focusin', updatePause);
      slider.addEventListener('focusout', function () {
        // Let activeElement update before checking whether focus left the slider.
        window.setTimeout(updatePause, 0);
      });
      if (hovered || slider.contains(document.activeElement)) updatePause();
    });
  }
  function start() {
    initializeSliders();
    new MutationObserver(initializeSliders).observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }



  //// Video Slider 
  (function () {
    const selector = '.slick-video-slider .slick-slide-item';

    function removeAttributes() {
      document.querySelectorAll(selector).forEach(function (slide) {
        if (slide.hasAttribute('aria-hidden')) {
          slide.removeAttribute('aria-hidden');
        }

        if (slide.hasAttribute('tabindex')) {
          slide.removeAttribute('tabindex');
        }
      });
    }

    function init() {
      removeAttributes();

      new MutationObserver(removeAttributes).observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'tabindex']
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  ///// label foe the menu
  document.querySelectorAll('.nav__link.nav__link--fill').forEach(link => {
    if (link.textContent.trim() === 'Learn More') {
      link.setAttribute('aria-label', 'Learn More about us');
    }
  });
// powermapper issue
  document.addEventListener('keydown', function (event) {
    const closeSearch = event.target.closest(
      'span[role="button"][aria-label="Close Search"]'
    );

    if (!closeSearch) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      BoosterTheme.ELEMENTS.closeSearch(closeSearch);
    }
  });




})();
